<template>
      <section class="workspace-section">
        <div class="section-header">
          <h2 v-if="props.title" class="title">{{ $t(props.title) }}</h2>
          <slot v-else name="header"></slot>
          <div class="section-actions">
            <slot name="header-actions"></slot>
          </div>
        </div>

        <slot name="default"></slot>
      </section>
</template>

<script setup lang="ts">

const props = defineProps({
  title: {
    type: String,
    required: false,
  }
});
</script>

<style scoped>
.workspace-section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 12px;
  padding-inline: 8px;
  min-height: 37px;
}

.section-header h2 {
  font-size: 1.2rem;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

</style>